import db from './../db';

export default {
    post: function(url, data) {
        return new Promise(function(resolve, reject) {
            const errors = [];

            //Title is required
            if (data.title === null || data.title === '') {
                errors.push(
                    {
                        property: 'Title',
                        message: 'MESSAGE__TODO__TITLE_REQUIRED'
                    }
                );
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            let maxId = 0;
            for (let i = 0; i < db.todos.length; i++) {
                if (db.todos[i].id >= maxId) {
                    maxId = db.todos[i].id + 1;
                }
            }

            db.todos.push({
                id: maxId,
                title: data.title,
                done: data.done
            });

            db.save();

            //Ok
            resolve({
                body: {
                    id: maxId,
                    title: data.title,
                    done: data.done
                }
            });
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/todo/create.js